export const brandOptions = ['Bluehost', 'HostGator'];

export const apiBaseUrlOptions = [
  'https://hosting-alpha.uapi.newfold.com',
  'https://huapi.beta.bh1.hosting.newfold.com',
  'https://huapi.beta.bh2.hosting.newfold.com',
  'https://hosting-staging.uapi.newfold.com',
  'https://hosting.uapi.newfold.com',
];
